export default __webpack_public_path__ + "static/media/logo-dark-retina-270x132.8d7046e0.png";